import { useState, useEffect } from "react";
import moment from "moment";

import { useAppDispatch, useAppSelector } from "../redux/hook";
import {
  showAddressModal,
  showCartModal,
  showAccountModal,
} from "../redux/actions";

import { isCustomerAddressDefined } from "../utils/customer-address-and-shops";
import { getNbTotalCommande } from "../utils";
import { logMediumLog } from "../utils/logger";
import { getOrderTimes } from "../utils/order";
import { useSignInSignUp } from "../hooks/useSignInSignUp";
import type { InfoBarHookReturn } from "../1_types/InfoBarTypes";

export const useInfoBar = (): InfoBarHookReturn => {
  const dispatch = useAppDispatch();

  const { isMobile, customerAddressCheck } = useAppSelector(
    (state) => state.componentReducer
  );
  const { handleOpenLogin, handleOpenSignup } = useSignInSignUp();
  const { userConnected, user } = useAppSelector((state) => state.userReducer);

  const { address: customerAddress, orderType } = useAppSelector(
    (state) => state.pendingOrderReducer
  );

  const { openHours, shopName, closed } = useAppSelector((state) => state.shopReducer);

  const { logoUrl, secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );

  const points = user?.points;

  const [firstSlot, setFirstSlot] = useState<string>("Maintenant");
  const isClosedShop = typeof closed === "string";
  const handleCartClick = (): void => {
    const addressDefined = isCustomerAddressDefined(customerAddress);

    if (!addressDefined) {
      logMediumLog("Cart without address");
    }

    dispatch(
      addressDefined && customerAddressCheck
        ? showCartModal(true)
        : showAddressModal(true)
    );
  };

  useEffect(() => {
    const fetchFirstSlot = async (): Promise<void> => {
      try {
        const slots = await getOrderTimes(moment());
        if (slots?.length) {
          setFirstSlot(slots[0].value);
        }
      } catch (error) {
        console.error("Failed to fetch order slots", error);
      }
    };

    fetchFirstSlot();
  }, []);

  const openAccount = (): void => {
    dispatch(showAccountModal(true));
  };

  const openAddress = (): void => {
    dispatch(showAddressModal(true));
  };

  return {
    isMobile,
    secondaryColor,
    userConnected,
    user,
    name: shopName,
    orderType,
    logoUrl,
    openHours,
    firstSlot,
    isClosedShop,
    points,
    nbCommande: getNbTotalCommande(),
    handlers: {
      handleCartClick,
      handleOpenLogin,
      handleOpenSignup,
      openAccount,
      openAddress,
    },
  };
};
